import { createContext } from "react";

const ThumbnailContext = createContext();

export default ThumbnailContext;